import instance from "../../services/axios";

const uri = {
    flightCountrySearchList: "/flight/get-code",
    flightOneWayResult: "/flight/search-flight2/oneway",
    getFlightDetails: "/flight/flight-review",
    flightroundcityResult: "/flight/search-flight2/roundcity",
    // fetchFlightBook: "flight/flight-book",
    // fetchFlightBookTripjack: "flight/payment-link",
    fetchFlightBookTripjackProceed: "/flight/flight-process",
    fetchConfirmAndPayTripjack: "/flight/pay-now",
    cancelChargePolicy: "flight/cancel-fare-rule",
    offers: "promotion/get-offers/flights",

    flightOneWayResultTwoTypeVender: "/vendor-flight/search-flight/oneway",
    fetchFlightDetailsTBO: "/vendor-flight/tbo-flight-review-2",
    flightRoundCityResultTwoTypeVender: "/vendor-flight/search-flight/roundcity",
    flightFlightDomesticList: "/popular-destination/popular-list/domestic",
    flightFlightInternationalList: "/popular-destination/popular-list/international",
    flightFlightContentList: "/flight/destination/",
    getHotelEnquiry: "/package/create-enquiry",
    fetchflightProcessTBO: "/vendor-flight/flight-process",
    payNowflightTBO: "/vendor-flight/pay-now",
    getTboGetMea: "/vendor-flight/tbo-get-meal",
    fetchpaymentStatus: "/payment-status",
    vendorCancelFareRule: "/vendor-flight/cancel-fare-rule",
    // getConvenienceCharge: "/convenience/convenience-charge",
    getConvenienceCharge: "/convenience/get-all-convenience",
    mailVerifyFunction: "/auth/sent-otp-email",
    otpConfirmationEmail: "/auth/otp-email-verified",
    getIPAddress: "http://ip-api.com/json",
    getIPData: (ip) => `https://mysuperb.app/v1/ip-data/${ip}`,
    pdfDownloadStatusPage: "payment/get-mail-pdf",
    getFlightOffersList: (type) => `/offers/get-offers/${type}`,
    getFlightBanners: "/promotion/banner"
};

export const getFlightSearchList = async (searchTerm) => {
    const API_KEY = import.meta.env.VITE_SMT_V2_API_KEY;
    const headers = {
        'api-key': API_KEY
    };

    try {
        const response = await instance.get(uri.flightCountrySearchList, {
            headers: headers,
            params: { cityCode: searchTerm }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching hotel search list:', error);
        throw error;
    }
};


export const getFlightRoundCityResultFilterData = async (reqBody) => {
    const API_KEY = import.meta.env.VITE_SMT_V2_API_KEY;
    const headers = {
        'api-key': API_KEY,
    };

    try {
        const response = await instance.post(uri.flightroundcityResult, reqBody, {
            headers: headers,
        });
        return response;
    } catch (error) {
        console.error('Error fetching data:', error);
        throw error;
    }
};



export const getFlightOneWayResultData = async (reqBody) => {
    const API_KEY = import.meta.env.VITE_SMT_V2_API_KEY;
    const headers = {
        'api-key': API_KEY,
    };

    try {
        const response = await instance.post(uri.flightOneWayResult, reqBody, {
            headers: headers,
        });
        return response;
    } catch (error) {
        console.error('Error fetching flight data:', error);
        throw error;
    }
};


export const getFlightDetails = async (payload) => {
    const API_KEY = import.meta.env.VITE_SMT_V2_API_KEY;
    const headers = {
        'api-key': API_KEY,
    };

    try {
        const response = await instance.post(uri.getFlightDetails, payload, {
            headers: headers,
        });
        return response;
    } catch (error) {
        console.error('Error fetching hotel search data:', error);
        throw error;
    }
};

export const fetchFlightBookTripjackProceed = async (payload) => {
    const API_KEY = import.meta.env.VITE_SMT_V2_API_KEY;
    const headers = {
        'api-key': API_KEY,
    };

    try {
        const response = await instance.post(uri.fetchFlightBookTripjackProceed, payload, { headers: headers });
        return response.data;
    } catch (error) {
        console.error('Error fetching flight book:', error);
        throw error;
    }
};


export const getCancelChargePolicy = async (payload) => {
    const API_KEY = import.meta.env.VITE_SMT_V2_API_KEY;
    const headers = {
        'api-key': API_KEY,
    };

    try {
        const response = await instance.post(uri.cancelChargePolicy, payload, {
            headers: headers,
        });
        return response;
    } catch (error) {
        console.error('Error fetching  data:', error);
        throw error;
    }
};


export const getFlightOffers = async () => {
    const API_KEY = import.meta.env.VITE_SMT_V2_API_KEY;
    const headers = {
        'api-key': API_KEY
    };

    try {
        const response = await instance.get(uri.offers, { headers: headers, });
        return response.data;
    } catch (error) {
        console.error('Error fetching flight offers list:', error);
        throw error;
    }
};


export const getFlightOneWayTwoTypeVender = async (reqBody) => {
    const API_KEY = import.meta.env.VITE_SMT_V2_API_KEY;
    const headers = {
        'api-key': API_KEY,
    };

    try {
        const response = await instance.post(uri.flightOneWayResultTwoTypeVender, reqBody, {
            headers: headers,
        });
        return response;
    } catch (error) {
        throw error;
    }
};


export const getFlightRoundCityTwoTypeVender = async (reqBody) => {
    const API_KEY = import.meta.env.VITE_SMT_V2_API_KEY;
    const headers = {
        'api-key': API_KEY,
    };

    try {
        const response = await instance.post(uri.flightRoundCityResultTwoTypeVender, reqBody, {
            headers: headers,
        });
        return response;
    } catch (error) {
        console.error('Error fetching flight data:', error);
        throw error;
    }
};

export const getFlightDetailsTBO = async (payload) => {
    const API_KEY = import.meta.env.VITE_SMT_V2_API_KEY;
    const headers = {
        'api-key': API_KEY,
    };

    try {
        const response = await instance.post(uri.fetchFlightDetailsTBO, payload, {
            headers: headers,
        });
        return response;
    } catch (error) {
        console.error('Error fetching hotel search data:', error);
        throw error;
    }
};


export const getFlightDomesticList = async () => {
    const API_KEY = import.meta.env.VITE_SMT_V2_API_KEY;
    const headers = {
        'api-key': API_KEY
    };

    try {
        const response = await instance.get(uri.flightFlightDomesticList, {
            headers: headers,
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching hotel search list:', error);
        throw error;
    }
};

export const getFlightInternationalList = async () => {
    const API_KEY = import.meta.env.VITE_SMT_V2_API_KEY;
    const headers = {
        'api-key': API_KEY
    };

    try {
        const response = await instance.get(uri.flightFlightInternationalList, {
            headers: headers,
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching hotel search list:', error);
        throw error;
    }
};


export const getFlightContentList = async (fromCode, toCode) => {
    const API_KEY = import.meta.env.VITE_SMT_V2_API_KEY;
    const headers = {
        'api-key': API_KEY
    };

    try {
        const response = await instance.get(`/flight/destination/${fromCode}/${toCode}`, { headers });
        return response.data;
    } catch (error) {
        console.error('Error fetching flight content list:', error);
        throw error;
    }
};



export const getHotelEnquiry = async (reqBody) => {
    const API_KEY = import.meta.env.VITE_SMT_V2_API_KEY;
    const headers = {
        'api-key': API_KEY,
    };

    try {
        const response = await instance.post(uri.getHotelEnquiry, reqBody, {
            headers: headers,
        });
        return response;
    } catch (error) {
        console.error('Error fetching flight data:', error);
        throw error;
    }
};


export const fetchflightProcessTBO = async (payload) => {
    const API_KEY = import.meta.env.VITE_SMT_V2_API_KEY;
    const headers = {
        'api-key': API_KEY,
    };

    try {
        const response = await instance.post(uri.fetchflightProcessTBO, payload, { headers: headers });
        return response.data;
    } catch (error) {
        console.error('Error fetching flight book:', error);
        throw error;
    }
};

export const payNowflightTBO = async (payload) => {
    const API_KEY = import.meta.env.VITE_SMT_V2_API_KEY;
    const headers = {
        'api-key': API_KEY,
    };

    try {
        const response = await instance.post(uri.payNowflightTBO, payload, { headers: headers });
        return response.data;
    } catch (error) {
        console.error('Error fetching flight book:', error);
        throw error;
    }
};



export const fetchTboMeaData = async (payload) => {
    const API_KEY = import.meta.env.VITE_SMT_V2_API_KEY;
    const headers = {
        'api-key': API_KEY,
    };

    try {
        const response = await instance.post(uri.getTboGetMea, payload, { headers: headers });
        return response.data;
    } catch (error) {
        console.error('Error fetching meal:', error);
        throw error;
    }
};


export const getFetchpaymentStatusList = async (payload) => {
    const API_KEY = import.meta.env.VITE_SMT_V2_API_KEY;
    const headers = {
        'api-key': API_KEY
    };
    try {
        const response = await instance.post(uri.fetchpaymentStatus, payload, { headers: headers });
        return response.data;
    } catch (error) {
        console.error('Error fetching payment status:', error);
        throw error;

    }
};

export const getVendorCancelFareRule = async (payload) => {
    const API_KEY = import.meta.env.VITE_SMT_V2_API_KEY;
    const headers = {
        'api-key': API_KEY
    };
    try {
        const response = await instance.post(uri.vendorCancelFareRule, payload, { headers: headers });
        return response.data;
    } catch (error) {
        console.error('Error fetching payment status:', error);
        throw error;

    }
};


export const getConvenienceCharge = async (params) => {
    const API_KEY = import.meta.env.VITE_SMT_V2_API_KEY;
    const headers = {
        'api-key': API_KEY
    };

    try {
        const response = await instance.get(`${uri.getConvenienceCharge}?type=${params.type}&category=${params.category}`, {
            headers: headers,
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching convenience charge:', error);
        throw error;
    }
};

// export const mailVerifyFunction = async (payload) => {
//     return await instance.post(uri.mailVerifyFunction, payload);
// };

export const mailVerifyFunction = async (payload) => {
    const API_KEY = import.meta.env.VITE_SMT_V2_API_KEY;
    const headers = {
        'api-key': API_KEY
    };
    try {
        const response = await instance.post(uri.mailVerifyFunction, payload, { headers: headers });
        return response.data;
    } catch (error) {
        console.error('Error fetching payment status:', error);
        throw error;
    }
};


export const getotpConfirmationEmail = async (payload) => {
    const API_KEY = import.meta.env.VITE_SMT_V2_API_KEY;
    const headers = {
        'api-key': API_KEY
    };
    try {
        const response = await instance.post(uri.otpConfirmationEmail, payload, { headers: headers });
        return response.data;
    } catch (error) {
        console.error('Error fetching payment status:', error);
        throw error;
    }
};

export const getIPAddress = async () => {
    try {
        const response = await instance.get(uri.getIPAddress);
        const data = {
            ip: response.data.query
        }
        return data;
    } catch (error) {
        throw error;
    }
}

export const getIPData = async (ip) => {
    try {
        const response = await instance.get(uri.getIPData(ip));
        return response.data;
    } catch (error) {
        console.error('Error fetching IP-based data:', error);
        throw error;
    }
};

export const pdfDownloadStatusPage = async (id) => {
    const API_KEY = import.meta.env.VITE_SMT_V2_API_KEY;

    const response = await instance.get(`${uri.pdfDownloadStatusPage}/${id}`, {
        headers: {
            'api-key': API_KEY,
        },
        responseType: 'blob',
    });

    return response.data;
};


export const payNowConfirmTripjack = async (payload) => {
    const API_KEY = import.meta.env.VITE_SMT_V2_API_KEY;
    const headers = {
        'api-key': API_KEY,
    };

    try {
        const response = await instance.post(uri.fetchConfirmAndPayTripjack, payload, { headers: headers });
        return response.data;
    } catch (error) {
        console.error('Error fetching flight book:', error);
        throw error;
    }
};


export const getFlightOffersList = async (type) => {
    const API_KEY = import.meta.env.VITE_SMT_V2_API_KEY;
    const headers = { "api-key": API_KEY };

    try {
        const response = await instance.get(uri.getFlightOffersList(type), {
            headers,
        });
        return response.data;
    } catch (error) {
        console.error(`Error fetching`, error);
        throw error;
    }
};

export const getFlightBanners = async (type) => {
    const API_KEY = import.meta.env.VITE_SMT_V2_API_KEY;
    const headers = { "api-key": API_KEY };

    try {
        const response = await instance.get(uri.getFlightBanners, {
            headers,
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};